import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, useParams } from 'react-router-dom';
import { FiLoader, FiArrowRight } from "react-icons/fi";
// Aapka existing check icon import kar rahe hain
import checkIcon from "../../assets/check.svg"; 
import { verifyInvoicesById } from '../../ApiController/ApiService'; 

const PaymentSuccess = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

   const {id}=useParams();

console.log("Invoice ID from URL:", id); // Debugging ke liye   
    const [loading, setLoading] = useState(true);
    const [isVerified, setIsVerified] = useState(false);

    useEffect(() => {
        const verifyPayment = async () => {
            if (!id ) {
                setLoading(false);
                return; 
            }

            try {
                const response = await verifyInvoicesById(id,{Status:"Paid"}
                  
           );

                if (response?.success || response?.status === 200) {
                    setIsVerified(true);
                }
            } catch (error) {
                console.error('Verification failed:', error);
            } finally {
                setLoading(false);
            }
        };
console.log("Starting payment verification for ID:", id); // Debugging ke liye
        verifyPayment();
    }, [id]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-[#080625] text-white p-4">
            <div 
                className="max-w-md w-full p-8 rounded-2xl shadow-2xl text-center relative overflow-hidden"
                style={{
                    background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)',
                    backdropFilter: 'blur(42.7px)'
                }}
            >
                {/* Loader jab tak API call chal rahi hai */}
                {loading ? (
                    <div className="flex flex-col items-center justify-center py-10">
                        <FiLoader className="text-[#6F1AFF] text-5xl animate-spin mb-4" />
                        <h2 className="text-xl font-semibold mb-2">Verifying Payment...</h2>
                        <p className="text-gray-400 text-sm">Please wait while we confirm your transaction.</p>
                    </div>
                ) : (
                    /* Success / Thank You UI */
                    <div className="flex flex-col items-center py-6 animate-fade-in">
                        <h2 style={{ fontFamily: "Poppins" }} className="text-2xl sm:text-[30px] font-bold text-white leading-tight mb-2">
                            Payment <span className="text-[#6F1AFF]">Successful!</span>
                        </h2>
                        
                        <p className="text-sm text-gray-400 mb-6">
                            Thank you! Your invoice has been paid successfully.
                        </p>
                        
                        <div className="flex justify-center mb-8">
                            <img src={checkIcon} alt="Success" className="w-32 sm:w-[150px] object-contain drop-shadow-lg" />
                        </div>
                        
                        <div className="bg-[#10194E] w-full rounded-lg p-4 mb-6 border border-[#1E2A60] text-left">
                            <p className="text-xs text-gray-400 mb-1">Invoice ID</p>
                            <p className="font-semibold text-sm text-cyan-400">{id || 'N/A'}</p>
                        </div>

                        <button
                            onClick={() => navigate('/invoices')} 
                            className="flex items-center justify-center gap-2 w-full py-3 bg-gradient-to-r from-[#6E00FF] to-[#A627FF] text-white rounded-xl hover:opacity-90 transition font-medium text-sm shadow-md"
                        >
                            Go Back to Dashboard
                            <FiArrowRight />
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PaymentSuccess;